import React from "react";
import { Text } from "react-native";
import { useAssessmentQuestionContext } from "../context/AssessmentQuestionContext";

export function AssessmentQuestionHeader() {
  const { question } = useAssessmentQuestionContext();
  const unit = question.unit ? `(${question.unit})` : "";
  return (
    <Text className="text-sm font-semibold my-3">
      {question.content} {unit}
    </Text>
  );
}
